/**
 * 変更履歴の登録結果に関する画面メッセージ (マスタ変更履歴 SBI 8)。
 *
 * 6 マスタの画面すべてで同じ文言を出すため、ここ 1 か所だけに持つ。
 * 画面ごとに言い換えない (利用者が「同じ警告」と認識でき、問い合わせ時の文言検索も 1 つで済む)。
 */

/** 保存は成功したが、変更履歴の登録に失敗したときの警告 */
export const HISTORY_RECORD_FAILED_MESSAGE =
  '保存は完了しました。ただし変更履歴の登録に失敗しました。変更内容の追跡ができない可能性があります。システム管理者へ連絡してください。';

/** 一括系で、履歴の登録に失敗した件数を併記するときの書式 */
export function historyFailedCountSuffix(count: number): string {
  return `(履歴の登録に失敗した件数: ${count} 件)`;
}
